//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        clickAreas: {
            type: Array,
            default: () => []
        },
        completed: {
            required: true,
            type: Boolean
        }
    },

    data () {
        return {
            areas: [],
            numClicks: 0,
            showHint: false
        };
    },

    computed: {
        numFound () {
            return this.areas.filter(area => area.alpha === 1).length;
        }
    },

    watch: {
        completed () {
            if (this.completed) {
                let result = this.$game.getSearchGameResult(this.numFound, this.areas.length, this.numClicks, this.showHint);
                this.$emit('set-result', result);
            }
        },
        numFound () {
            this.$emit('set-num-found', this.numFound);
        }
    },

    created () {
        this.areas = this.clickAreas.map(clickArea => ({
            ...clickArea,
            alpha: 0
        }));
    },

    methods: {
        addClick () {
            this.numClicks++;

            if (this.numClicks === 3 && this.numFound === 0) {
                this.showHint = true;
                this.$emit('show-hint');
            }
        },
        foundClickArea (area) {
            if (!this.completed) {
                area.alpha = 1;
            }
        },
    }
};
